import { render, staticRenderFns } from "./im_supervise_new.vue?vue&type=template&id=7a6c22db"
import script from "./im_supervise_new.vue?vue&type=script&lang=ts"
export * from "./im_supervise_new.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports